/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { MyButton } from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { pushOneTerms } from "../../../../middlewares/sysNavigation/SysNavigation";

const editRoute = "/terms/edit";

const Overview = () => {
  const [termsList, setTermsList] = useState([]);
  const { terms, fetchTerms } = useStaticContext();

  useEffect(() => {
    if (!terms) fetchTerms();
    else setTermsList(terms);
  }, [terms]);

  const hasData = Array.isArray(termsList) && termsList.length > 0;

  return (
    <div className="p-3 lg:p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-7xl">
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Terms Overview
              </h1>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Manage your Terms &amp; Conditions content
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Items: {hasData ? termsList.length : 0}
            </span>
          </div>
        </div>

        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/2 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Title
                  </th>
                  <th className="w-1/2 border-b border-gray-200 px-4 py-3 text-center font-semibold text-gray-700">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {terms ? (
                  hasData ? (
                    termsList.map((trm) => (
                      <tr key={trm?.terms_id} className="transition-colors hover:bg-gray-50">
                        <td className="px-4 py-3 align-top text-gray-900">
                          <span className="block">Terms &amp; Conditions</span>
                        </td>
                        <td className="px-4 py-3">
                          <ActionButton props={trm} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="px-4 py-8 text-center text-sm text-gray-500" colSpan={2}>
                        No terms added yet.
                      </td>
                    </tr>
                  )
                ) : (
                  Array.from({ length: 3 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-3">
                        <div className="h-4 w-48 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="mx-auto h-9 w-24 rounded bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <p className="mt-3 text-[11px] text-gray-500">
          Keep your terms concise and easy to scan.
        </p>
      </div>
    </div>
  );
};

const ActionButton = ({ props }) => {
  return (
    <div className="flex items-center justify-center">
      <Link to={editRoute}>
        <MyButton
          title="Edit"
          className="rounded-lg bg-blue-600 px-3 py-2 text-xs font-semibold shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          onClick={() => pushOneTerms(props)}
        />
      </Link>
    </div>
  );
};

export default Overview;
